import { forwardRef, useEffect, useRef } from "react";

import { type ReactMaskOpts, useIMask } from "react-imask";

import { TextInput, type TextInputProps } from "./text-input";

interface MaskedInputProps extends TextInputProps {
  maskOptions: ReactMaskOpts;
  validator?: (v: string | null | undefined) => boolean;
}

export const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>(
  ({ maskOptions, value, onChange, validator, ...props }, ref) => {
    const initiallyAccepted = useRef(false);

    const {
      ref: maskRef,
      setValue: setMaskedValue,
      setUnmaskedValue,
      value: maskedValue,
    } = useIMask(maskOptions, {
      onAccept: (val, r) => {
        if (initiallyAccepted.current) {
          setMaskedValue(val);
          if (!validator || validator(r.typedValue)) {
            onChange?.(r.typedValue);
          }
        } else {
          initiallyAccepted.current = true;
        }
      },
    });

    useEffect(() => {
      if (value !== undefined) {
        setUnmaskedValue(value);
      }
    }, [value, setUnmaskedValue]);

    return (
      <TextInput
        {...props}
        value={maskedValue}
        ref={(ins) => {
          if (typeof ref === "function") {
            ref(ins);
          } else if (ref) {
            ref.current = ins;
          }
          maskRef.current = ins;
        }}
      />
    );
  },
);
